// Impostazioni → Lavori automatici (solo admin, GET /api/admin/lavori-automatici): due righe di sola lettura.
//
// Risponde a una domanda che altrimenti si risolve solo aprendo i log di Railway: i solleciti e le scadenze dei
// documenti stanno girando davvero? Senza `PROMEMORIA_ATTIVI` i giri delle 8 non partono e la sezione Documenti
// sembra funzionare mentre non manda niente a nessuno — il 19/10/2026 non si poteva sapere da nessuna parte.
//
// La seconda riga è il cestino: dal 19/10/2026 la cancellazione a 30 giorni dei clienti eliminati è **spenta di
// base**, e se qualcuno l'accende è giusto vederlo scritto, perché è l'unica cosa che cancella documenti da sola.
//
// Niente valori e nessun nome di variabile d'ambiente: a chi guarda la pagina non servono, e un elenco di nomi è
// una mappa di cosa cercare.
import React, { useEffect, useState } from 'react';
import { API, axios } from '../../utils/api';
import Icona from '../cliente/Icone';

const RIGHE = [
  {
    chiave: 'promemoria',
    nome: 'Promemoria e solleciti',
    acceso: 'attivi',
    spento: 'spenti',
    // spento non è un guasto: su un ambiente di prova è giusto così. Per questo il tono è neutro.
    nota: 'Promemoria delle visite, scadenze dei documenti a 90/30/7 giorni, rinnovo dei periodici e solleciti '
      + 'delle richieste. Da spenti la sezione Documenti funziona, ma non manda niente da sola.',
  },
  {
    chiave: 'ricontrolli_candidate',
    nome: 'Ricontrolli delle candidate',
    // tre stati, non due: la riga mostra la parola che arriva dal server
    stati: true,
    nota: 'Rilettura delle candidate sui portali con l\u2019estensione: se sono ancora online, se il prezzo è '
      + 'cambiato, la sede dell\u2019agenzia. Si cambia da Impostazioni → Estrattore.',
  },
  {
    chiave: 'archivio_automatico',
    nome: 'Archivio delle candidate',
    oggetto: true,   // lo stato sta dentro un oggetto, insieme all'esito dell'ultimo giro
    nota: 'Ogni mattina alle 8:30 mette in archivio le candidate che nessuno ha guardato da 14 giorni. Non '
      + 'cancella niente. Si cambia da Impostazioni → Estrattore.',
  },
  {
    chiave: 'cestino_automatico',
    nome: 'Cestino automatico',
    acceso: 'acceso',
    spento: 'spento',
    nota: 'Da acceso, trenta giorni dopo che un cliente è stato eliminato spariscono per sempre i suoi documenti '
      + 'e le foto delle visite. Da spento resta tutto nel cestino finché un admin non elimina definitivamente.',
  },
];

// L'esito dell'ultimo giro dell'archivio: quando, quante, e se si è fermato perché. Serve a rispondere alla
// domanda «ha girato stamattina?» senza aprire i log.
const esitoGiro = (dato) => {
  const giro = (dato || {}).ultimo_giro;
  if (!giro) return ' Non ha ancora girato.';
  const quando = giro.quando ? new Date(giro.quando).toLocaleString('it-IT') : '?';
  if (giro.fermo) return ` Ultimo giro ${quando}: ${giro.fermo}.`;
  return ` Ultimo giro ${quando}: ${giro.archiviate ?? 0} messe in archivio.`;
};

const LavoriAutomatici = () => {
  const [dati, setDati] = useState(null);
  const [problema, setProblema] = useState(false);
  useEffect(() => {
    axios.get(`${API}/admin/lavori-automatici`).then((r) => setDati(r.data)).catch(() => setProblema(true));
  }, []);

  if (problema) {
    return (
      <div className="imp-griglia" data-testid="lavori-automatici-problema">
        <section className="card">
          <div className="ttl"><div className="i r"><Icona nome="avviso" /></div><h2>Lavori automatici</h2></div>
          <p className="imp-nota">Lo stato non è arrivato dal server: ricaricate la pagina fra poco.</p>
        </section>
      </div>
    );
  }
  if (!dati) return null;

  return (
    <div className="imp-griglia" data-testid="lavori-automatici">
      <section className="card">
        <div className="ttl"><h2>Lavori automatici <small>cosa sta girando adesso</small></h2></div>
        <p className="imp-nota">
          Letto dalla configurazione del server in esecuzione. Per cambiarli si cambia la configurazione su
          Railway e il server riparte: da questa pagina non si accende e non si spegne niente.
        </p>
        <div className="kv" style={{ marginTop: '.8rem' }}>
          {RIGHE.map((riga) => {
            // le righe a tre stati portano la parola dal server («spento», «prova», «acceso»); le altre sono sì/no
            const grezzo = dati[riga.chiave];
            const valore = riga.oggetto ? (grezzo || {}).stato : grezzo;
            const attivo = (riga.stati || riga.oggetto) ? valore !== 'spento' : Boolean(valore);
            const testo = (riga.stati || riga.oggetto) ? (valore || 'spento') : (attivo ? riga.acceso : riga.spento);
            return (
              <div key={riga.chiave} data-testid={`lavoro-${riga.chiave}`}>
                <small>{riga.nome}</small>
                <b className={attivo ? 'g' : 'w'}>{testo}</b>
              </div>
            );
          })}
        </div>
        {RIGHE.map((riga) => (
          <p className="imp-nota" key={riga.chiave} style={{ marginTop: '.6rem' }}>
            <b>{riga.nome}.</b> {riga.nota}
            {riga.oggetto && esitoGiro(dati[riga.chiave])}
          </p>
        ))}
      </section>
    </div>
  );
};

export default LavoriAutomatici;
